import { sessionStore } from '../lib/session-store';

export function markSessionExpired(): void {
  const session = sessionStore.read();
  if (session && !session.expired) sessionStore.write({ ...session, expired: true });
}
